import axios from 'axios';
import { baseURLByEnv, env } from 'core/config';
import { fetchAuthSession } from 'aws-amplify/auth';
import { organizationLocalStorageItem } from 'services/organization/atom';

const apiClient = axios.create({
  baseURL: baseURLByEnv[env.STAGE],
  headers: {
    'Content-Type': 'application/json'
  }
});

apiClient.interceptors.request.use(
  async (config) => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      const organization = organizationLocalStorageItem();
      if (organization && organization.id) {
        config.headers['organization-id'] = organization.id;
      }
    } catch (error) {
      console.error('Error fetching the token: ', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
